import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function PatientListIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 24 24">
      <path
        d="M16 14a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 13 11q0-1.25.875-2.125A2.9 2.9 0 0 1 16 8q1.25 0 2.125.875T19 11t-.875 2.125A2.9 2.9 0 0 1 16 14m-5 6a.97.97 0 0 1-.713-.288A.97.97 0 0 1 10 19v-.9q0-.525.25-1 .25-.476.7-.75a9.3 9.3 0 0 1 2.388-1.013A10.3 10.3 0 0 1 16 15q1.399 0 2.663.338a9.3 9.3 0 0 1 2.387 1.012q.45.274.7.75.25.475.25 1v.9q0 .424-.288.712A.97.97 0 0 1 21 20zm-1-6H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 13q0-.424.288-.713A.97.97 0 0 1 4 12h6q.424 0 .713.287.287.288.287.713 0 .424-.287.713A.97.97 0 0 1 10 14m4-8H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 5q0-.424.288-.713A.97.97 0 0 1 4 4h10q.424 0 .713.287Q15 4.576 15 5t-.287.713A.97.97 0 0 1 14 6m-2.9 4H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 9q0-.424.288-.713A.97.97 0 0 1 4 8h8q-.35.425-.562.925A6 6 0 0 0 11.1 10"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
